/**
 * Skeleton route fallback — replaces the centred-spinner `RouteLoadingFallback`.
 *
 * Perceived performance bump: instead of staring at a blank screen with a
 * dot, the user sees a structural shimmer that hints at the page coming in.
 *
 * The skeleton intentionally mimics a generic "page hero + content cards"
 * layout so it works for almost every lazy-loaded route.
 */
function ShimmerBlock({ className = '' }) {
  return (
    <div
      className={`bg-theme-secondary/70 rounded-lg overflow-hidden relative ${className}`}
      data-testid="skeleton-block"
    >
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent" />
    </div>
  );
}

export default function RouteSkeleton() {
  return (
    <div className="min-h-[60vh] bg-theme px-4 py-8 sm:px-6 lg:px-8" data-testid="route-skeleton">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Hero */}
        <div className="space-y-3">
          <ShimmerBlock className="h-7 w-1/3" />
          <ShimmerBlock className="h-4 w-2/3" />
        </div>
        {/* Filter / actions row */}
        <div className="flex flex-wrap gap-3">
          <ShimmerBlock className="h-10 w-32" />
          <ShimmerBlock className="h-10 w-24" />
          <ShimmerBlock className="h-10 flex-1 min-w-[200px]" />
        </div>
        {/* Card grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <ShimmerBlock key={i} className="h-48" />
          ))}
        </div>
      </div>
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
